/* src/app/ships/ship-pending/ship-pending.component.css */
/*# sourceMappingURL=ship-pending.component.css.map */
